import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './SimpleHeader.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown';

class SimpleHeader extends Component {
  static propTypes = {
    filter: PropTypes.shape({
      options: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          label: PropTypes.string,
        })
      ).isRequired,
      selected: PropTypes.string,
    }),
    label: PropTypes.string,
    onFilterOptionSelect: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
    };

    this.hasFilter =
      this.props.filter !== undefined && this.props.filter.options.length > 0;
  }

  handleFilterClick = (event) => {
    event.preventDefault();
    if (this.hasFilter) {
      this.setState({
        showFilter: true,
      });
    }
  };

  handleOptionClick = (event, id) => {
    event.preventDefault();

    this.setState({
      showFilter: false,
    });

    if (this.props.onFilterOptionSelect !== undefined) {
      this.props.onFilterOptionSelect(id);
    }
  };

  handleOverlayClick = (event) => {
    event.preventDefault();
    this.setState({
      showFilter: false,
    });
  };

  render() {
    return (
      <div id="simple-header" className="simple-header">
        <div
          className={this.hasFilter ? 'has-filter' : ''}
          onClick={this.handleFilterClick}
        >
          <span>{this.props.label}</span>
          {this.hasFilter && (
            <span className="icon">
              <FontAwesomeIcon icon={faAngleDown} />
            </span>
          )}
        </div>
        {this.hasFilter && this.state.showFilter && (
          <div className="filter-container-parent">
            <div className="filter-container">
              <div>{this.props.label}</div>
              <ul>
                {this.props.filter.options.map((element) => {
                  return (
                    <li
                      key={element.id}
                      className={
                        element.id === this.props.filter.selected
                          ? 'selected'
                          : ''
                      }
                      onClick={(event) =>
                        this.handleOptionClick(event, element.id)
                      }
                    >
                      {element.label}
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="filter-overlay" onClick={this.handleOverlayClick} />
          </div>
        )}
      </div>
    );
  }
}

export default SimpleHeader;



// WEBPACK FOOTER //
// ./src/components/shared/table/SimpleHeader.js